import React from 'react'
import './Tabs.scss'
const Tabs = ({children}) => {
  return <div className="c-tabs">{children}</div>
}

export default Tabs
